import {Component, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from '@services/local-storage.service';
import {environment} from '@env/environment';
import {CustomerService} from '@services/customer-service';
import {NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet} from '@angular/router';
import {filter, take} from 'rxjs';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {LedgerSyncSpinner} from '@spinner';
import {NotificationComponent} from '@shared/notifications/notification.component';
import {ChunkLoadErrorService} from '@services/chunk-load-error.service';
import {TaskCenterRealtimeService} from './pages/task-center/task-center-realtime.service';

const AVAILABLE_LANGUAGES = ['fr', 'en', 'es'];

@Component({
  selector: 'ledger-sync-application',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TranslateModule,
    LedgerSyncSpinner,
    NotificationComponent
  ]
})
export class AppComponent {
  private translate = inject(TranslateService);
  private localStorageService = inject(LocalStorageService);
  private customerService = inject(CustomerService);
  private chunkLoadErrorService = inject(ChunkLoadErrorService);
  private taskCenterRealtimeService = inject(TaskCenterRealtimeService);
  private router = inject(Router);

  constructor() {
    void this.chunkLoadErrorService;
    this.removeBootLoaderWhenReady();
    this.setLanguage();
    this.initCustomerLogo();
    if (this.localStorageService.isAuthenticated()) {
      this.taskCenterRealtimeService.connect();
    }
  }

  /**
   * Keep the index.html boot loader visible until the first route has actually
   * finished loading (lazy chunk downloaded + component rendered), then remove it.
   */
  private removeBootLoaderWhenReady() {
    this.router.events.pipe(
      filter((event) =>
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError),
      take(1),
    ).subscribe(() => document.getElementById('app-boot-loader')?.remove());
  }

  private initCustomerLogo() {
    this.customerService.getLogo(
      this.localStorageService.getValue('company') || 'lender'
    ).subscribe({
      next: (resp) => this.customerService.logo.next(resp || {}),
      error: () => this.customerService.logo.next({})
    });
  }

  /**
   * set language
   */
  private setLanguage() {
    // this.translate.setDefaultLang(environment.DEFAULT_LANG);
    const hasValue = this.localStorageService.hasValue('app.lang');
    if (hasValue) {
      const langValue = this.localStorageService.getLang();
      if (AVAILABLE_LANGUAGES.includes(langValue) && langValue !== environment.DEFAULT_LANG) {
        this.translate.use(langValue);
      }
    }
  }
}
